import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMyWorksToDo(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_DO,
    ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO].GET_MY_WORKS_TO_DO,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO].GET_MY_WORKS_TO_DO]: _getMyWorksToDo
}